'use client';
import {
  DynamicHomeGameSections,
  HomeGameSections,
  type HomeGamesResponse,
} from '@/widgets/game-sections';
import { GamesPageShell } from '@/widgets/games-page-shell';
import { TopEventsSection } from '@/widgets/betting-home';
import { News } from '@/features/news-management';
import { getBrandData } from '@/shared/hooks/useBrandTheme';
import type { PageMetadata } from '@/shared/hooks/usePageMetadata';

const bettingEnabled = getBrandData().brandTheme.features.betting;

interface HomeClientContentProps {
  initialPageMetadata?: PageMetadata | null;
  initialHomeGames?: HomeGamesResponse | null;
}

const HomeClientContent = ({
  initialPageMetadata = null,
  initialHomeGames = null,
}: HomeClientContentProps) => (
  <GamesPageShell
    initialPageMetadata={initialPageMetadata}
    beforeBanners={<News />}
    renderSections={(openNotAllowedModal) => (
      <>
        {initialHomeGames ? (
          <HomeGameSections
            initialHomeGames={initialHomeGames}
            openNotAllowedModal={openNotAllowedModal}
          />
        ) : (
          <DynamicHomeGameSections openNotAllowedModal={openNotAllowedModal} />
        )}
        {bettingEnabled && <TopEventsSection />}
      </>
    )}
  />
);

export { HomeClientContent };
